import React from 'react';
import {
  ButtonPrimary,
  ButtonSecondary,
  dlsBrightBlue,
  IconWarning,
  Heading,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

export const FxErrorComponent = ({
  id,
  children,
  primaryButtonLabel,
  onPrimaryButtonClick,
  secondaryButtonLabel,
  onSecondaryButtonClick,
}) => {
  const primaryButton = primaryButtonLabel && onPrimaryButtonClick && (
    <ButtonPrimary
      id={`${id}-ButtonPrimary`}
      className="fluid-sm-down"
      onClick={onPrimaryButtonClick}
    >
      {primaryButtonLabel}
    </ButtonPrimary>
  );

  const secondaryButton = secondaryButtonLabel && onSecondaryButtonClick && (
    <ButtonSecondary
      id={`${id}-ButtonSecondary`}
      className="margin-1-l-md-up fluid-sm-down"
      onClick={onSecondaryButtonClick}
    >
      {secondaryButtonLabel}
    </ButtonSecondary>
  );

  return (
    <div className="flex flex-column flex-justify-center flex-align-items-center text-align-center stack">
      <IconWarning size="lg" theme={dlsBrightBlue} />
      {children}
      {(primaryButton || secondaryButton) && (
        <div className="stack-1-sm-down">
          {primaryButton}
          {secondaryButton}
        </div>
      )}
    </div>
  );
};

FxErrorComponent.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  primaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func,
};

FxErrorComponent.defaultProps = {
  id: 'error-component',
  children: (
    <div>
      <Heading className="margin-2-b" level={1} headingStyle="heading5">
        We’re unable to load this page at this time
      </Heading>
      <p className="body-3">Please try again after sometime.</p>
    </div>
  ),
  primaryButtonLabel: '',
  onPrimaryButtonClick: null,
  secondaryButtonLabel: '',
  onSecondaryButtonClick: null,
};
